// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "body-module--base-text-alt--global--dcec7";
export var baseTextGlobal = "body-module--base-text--global--c164a";
export var blockSpacing100 = "body-module--block-spacing-100--4c35a";
export var blockSpacing50 = "body-module--block-spacing-50--ba4b3";
export var blockVPadding100 = "body-module--block-v-padding-100--eba53";
export var blockVPadding50 = "body-module--block-v-padding-50--7e63e";
export var captionTextGlobal = "body-module--caption-text--global--fe919";
export var cmsRenderedContentGlobal = "body-module--cms-rendered-content--global--4e02f";
export var container = "body-module--container--97588";
export var defaultHSpacingGlobal = "body-module--default-h-spacing--global--eba41";
export var fadeInAnimation = "body-module--fadeInAnimation--93a11";
export var fadeInOnLoadGlobal = "body-module--fade-in-on-load--global--3fd11";
export var fullHeightGlobal = "body-module--full-height--global--954bb";
export var fullHeightOmittingNavGlobal = "body-module--full-height-omitting-nav--global--2e124";
export var headingTextGlobal = "body-module--heading-text--global--6796b";
export var ingressTextGlobal = "body-module--ingress-text--global--6df9e";
export var linkColorChangeTransitionGlobal = "body-module--link-color-change-transition--global--4fb4b";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "body-module--page-heading-text--global--35904";
export var paragraphTextGlobal = "body-module--paragraph-text--global--5f140";
export var subheadingTextGlobal = "body-module--subheading-text--global--d31ba";